import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'vigenciaTributo'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/concessionarias/${id}/tributos`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/tributos/${id}`

    case 'import':
      return '/tributos/import'

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingVigenciaTributoSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingVigenciaTributoSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_VIGENCIA_TRIBUTO_SUCCESS = 'LOADING_VIGENCIA_TRIBUTO_SUCCESS'
export function loadingVigenciaTributoSuccess(vigenciaTributo) {
  return {
    type: LOADING_VIGENCIA_TRIBUTO_SUCCESS,
    vigenciaTributo,
  }
}

export const DESTROYING_VIGENCIA_TRIBUTO_SUCCESS =
  'DESTROYING_VIGENCIA_TRIBUTO_SUCCESS'
export function destroyingVigenciaTributoSuccess(vigenciaTributoId) {
  return {
    type: DESTROYING_VIGENCIA_TRIBUTO_SUCCESS,
    vigenciaTributoId,
  }
}

export function fetchMultipleVigenciaTributo(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchVigenciaTributo(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createVigenciaTributo(parentId, vigenciaTributo) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      vigenciaTributo
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateVigenciaTributo(id, vigenciaTributo) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', vigenciaTributo).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyVigenciaTributo(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

export function importVigenciaTributo(multipleVigenciaTributo) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint('import'), 'POST', multipleVigenciaTributo).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

const vigenciaTributo = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_VIGENCIA_TRIBUTO_SUCCESS: {
      const { vigenciaTributo: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_VIGENCIA_TRIBUTO_SUCCESS:
      return state.delete(action.vigenciaTributoId.toString())

    default:
      return state
  }
}

export default vigenciaTributo
